import { NgModule } from '@angular/core';

import { TinymceEditComponent } from './tinymce-editor.component';

@NgModule({
  declarations: [TinymceEditComponent],
  exports: [TinymceEditComponent],
})
export class DtTinymceEditorModule {}
